function blockSliderOneImageResize(){
    const slider = document.getElementById("block-slider-one");

    if(slider){
        var sliderImages = slider.querySelectorAll('.image');

        sliderImages.forEach(imageElement => {
            var imageContainerWidth = slider.clientWidth;
            if(window.innerWidth >= 1640){
                var squareImageWidth = (imageContainerWidth * 0.33) - 30;
            } else if(window.innerWidth >= 680 && window.innerWidth < 1640){
                var squareImageWidth = (imageContainerWidth * 0.33) - 20;
            }else if(window.innerWidth < 680){
                var squareImageWidth = (imageContainerWidth * 0.75);
            }
            imageElement.style.cssText = 'max-height:' + squareImageWidth + 'px';
        });

        let block = document.getElementsByClassName('block-slider-one');
        let element = block[0];

        if(element){
             const splide1 = new Splide('#block-slider-one', {
                breakpoints: {
                    425: {
                        drag: true
                    }
                },
                perPage: 1,
                perMove: 1,
                pagination: false,
                drag: false,
                autoHeight: true,
                dragMinThreshold: 10,
                speed: 500
            });

            splide1.mount();

            const resizeContainer = (index) => {
                let sliderContainer = slider.getElementsByClassName('splide__track')[0];
                let indexSlide = splide1.Components.Controller.getIndex() + 1;
                if(index){
                    indexSlide = index;
                }
                let container = document.getElementById('slide-'+indexSlide);
                let maxHeight = container.offsetHeight + 50;

                sliderContainer.style.cssText = sliderContainer.getAttribute('style') + 'max-height:'+maxHeight+ 'px;';
            }

            resizeContainer(1);

            let pageIndexer = element.getElementsByClassName('page-number')[0]
            let pageNumber = parseInt(pageIndexer.getAttribute('data-number'));
            let index = splide1.Components.Controller.getIndex();
            let prev = index;
            pageIndexer.innerHTML = (index+1) +' / '+pageNumber;
            splide1.on('moved', function () {
                resizeContainer();
                prev = index;
                index = splide1.Components.Controller.getIndex();
                pageIndexer.innerHTML = (index+1) +' / '+pageNumber;

                let prevTitle = document.querySelector('[data-index="'+prev+'"]');
                let currentTitle = document.querySelector('[data-index="'+index+'"]');

                prevTitle.classList.remove('active');
                currentTitle.classList.add('active');
            });

            let titles = element.getElementsByClassName('title');
            let titlesTab = [...titles];

            let nextLinks = element.getElementsByClassName('next-link');
            let nextLinksTab = [...nextLinks];

            titlesTab.forEach(title => {
                title.addEventListener('click', () => {
                    let elementIndex = document.getElementById('block-slider-one');
                    let currentIndex = parseInt(elementIndex.getAttribute('data-global-index'));
                    let choiceIndex = parseInt(title.getAttribute('data-index'));
                    splide1.go(choiceIndex);

                    elementIndex.setAttribute('data-global-index', choiceIndex);
                    pageIndexer.innerHTML = (choiceIndex+1) +' / '+pageNumber;

                    let prevTitle = document.querySelector('[data-index="'+currentIndex+'"]');
                    let currentTitle = document.querySelector('[data-index="'+choiceIndex+'"]');

                    prevTitle.classList.remove('active');
                    currentTitle.classList.add('active');
                })
            });

            nextLinksTab.forEach(nextLink => {
                nextLink.addEventListener('click', () => {
                    let elementIndex = document.getElementById('block-slider-one');
                    let currentIndex = parseInt(elementIndex.getAttribute('data-global-index'));
                    let choiceIndex = parseInt(nextLink.getAttribute('next-data-index'));
                    splide1.go(choiceIndex);

                    elementIndex.setAttribute('data-global-index', choiceIndex);
                    pageIndexer.innerHTML = (choiceIndex+1) +' / '+pageNumber;

                    let prevTitle = document.querySelector('[data-index="'+currentIndex+'"]');
                    let currentTitle = document.querySelector('[data-index="'+choiceIndex+'"]');

                    prevTitle.classList.remove('active');
                    currentTitle.classList.add('active');
                })
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", function() {
    blockSliderOneImageResize();
});

// window.addEventListener("resize", function(){
//     blockSliderOneImageResize();
// });